import { MutationTree } from 'vuex'

import { PlaceState } from '@/types/store'
import { IPlace } from '@/types/place'

export const mutations: MutationTree<PlaceState> = {
  placesLoaded(state, payload: IPlace[]) {
    state.places = payload
  },
}
